<template>
  <div class="file-row" data-cy="search-item" :data-id="file.id">
    <Thumbnail :file="file" :style="{ width: `${height / 9 * 16}px`, height: `${height}px` }"></Thumbnail>
    <div class="title" :style="{ height: `${height}px` }">
      <div class="name truncate max-w-200px" :title="file.name">{{ file.name }}</div>
      <span class="text-tran-50 truncate comments max-w-200px inline-block" :title="projectName">{{ projectName }} </span>
      <span class="text-tran-50 truncate comments inline-block">&nbsp;·&nbsp;{{ file.create_date || getNowDateTime() }}
      </span>
    </div>
    <div class="tags">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Asset } from '@/types'
import { computed } from 'vue';
import Thumbnail from '@/components/Bussiness/Thumbnail.vue'
import { useStore } from '@/store';
import { getNowDateTime } from '@/utils/utils';

const store = useStore()
const { file, height } = defineProps<{
  file: Asset,
  height: number
}>()

const projectName = computed(() => {
  return file.project && file.project.name || store.state.currentProject?.name
})

</script>
<style lang="stylus" scoped>
.file-row {
  display: flex;
  padding: 6px;
}
.comments {
  font-size:12px;
  color:#6b6c6f;
}
.title {
  margin-left: 10px
  line-height: 20px
  flex-grow: 1
}
.tags {
  margin-left: 10px
  width: 100px
}
</style>